import { useEffect, useRef } from "react";

export function parseProgramUtcDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  let raw = String(value).trim().replace(" ", "T");
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw += "T00:00:00";
  if (!/(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw)) raw += "Z";
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatProgramArchiveDate(value) {
  return parseProgramUtcDate(value)?.toLocaleDateString("tr-TR", { timeZone: "Europe/Istanbul" }) || "—";
}

export function formatProgramArchiveDateTime(value) {
  return parseProgramUtcDate(value)?.toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" }) || "—";
}

export function archiveWorkLabel(step) {
  return `${Number(step.ordinal) || "—"}. çalışma`;
}

export function archivePhaseNumber(step) {
  const display = Number(step.display_phase_number);
  if (display > 0 && display < 1000) return display;
  const phase = Number(step.phase_number);
  if (phase > 0 && phase < 1000) return phase;
  return step.ordinal ? Math.floor((Number(step.ordinal) - 1) / 15) + 1 : "—";
}

export function useProgramStatusRefresh({ enabled, status, nextTransitionAt, refresh }) {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;
  useEffect(() => {
    if (!enabled || status === "completed") return undefined;
    let inFlight = false;
    const update = () => {
      if (!inFlight && document.visibilityState === "visible" && typeof refreshRef.current === "function") {
        inFlight = true;
        Promise.resolve().then(() => refreshRef.current()).catch(() => {}).finally(() => { inFlight = false; });
      }
    };
    update();
    const interval = window.setInterval(update, 30000);
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);
    const transition = parseProgramUtcDate(nextTransitionAt);
    const timer = transition && ["waiting_next_day", "resting"].includes(status)
      ? window.setTimeout(update, Math.min(Math.max(0, transition.getTime() - Date.now() + 750), 2147483647))
      : null;
    return () => {
      window.clearInterval(interval);
      if (timer !== null) window.clearTimeout(timer);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, [enabled, status, nextTransitionAt]);
}
